export default "__VITE_ASSET__C1Zr5iol__"